"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncidentResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const transform_config_1 = require("../../transform-config");
const users_1 = require("../users");
const enums_1 = require("../../enums");
class IncidentResponseDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        Object.assign(this, options);
    }
    getFields() {
        return [
            'id',
            'date',
            'incidentTypeId',
            'incidentPlaceId',
            'description',
            'participants',
            'referrals',
            'reporterId',
            'reporter',
            'status',
            'deletedAt',
            'incidentNumber'
        ];
    }
    id;
    schoolId;
    date;
    deletedAt;
    incidentTypeId;
    incidentPlaceId;
    incidentNumber;
    description;
    participants;
    referrals;
    reporterId;
    reporter;
    status;
    getTransforms() {
        return [
            {
                destination: 'date',
                transform: transform_config_1.TransformConfig.transformDateToTimestamp('date'),
                sourceFields: ['date']
            },
            {
                destination: 'deletedAt',
                transform: transform_config_1.TransformConfig.transformDateToTimestamp('deletedAt'),
                sourceFields: ['deletedAt']
            }
        ];
    }
}
exports.IncidentResponseDto = IncidentResponseDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], IncidentResponseDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], IncidentResponseDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], IncidentResponseDto.prototype, "date", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], IncidentResponseDto.prototype, "deletedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], IncidentResponseDto.prototype, "incidentTypeId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], IncidentResponseDto.prototype, "incidentPlaceId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], IncidentResponseDto.prototype, "incidentNumber", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], IncidentResponseDto.prototype, "description", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], IncidentResponseDto.prototype, "participants", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], IncidentResponseDto.prototype, "referrals", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], IncidentResponseDto.prototype, "reporterId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", users_1.UserBasicResponseDto)
], IncidentResponseDto.prototype, "reporter", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], IncidentResponseDto.prototype, "status", void 0);
